import React, { FC, useState, useEffect, useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { Grid, Header, Container, Icon, Menu, Button } from 'semantic-ui-react'

import { SliderVideo, SliderContainer, TextDiv, SliderHeader, InvertedButton, ContactsContainer, Helper } from './style'

import { Contacts } from '@/components/Contacts';

export const SliderComponent = ({ drupalHost, currentAct }) => {
    const dispatch = useDispatch<any>();

    const handleClick = () => dispatch({ type: 'TOGGLE_WIZARD' })

    return (
        <SliderContainer>
            <SliderVideo autoPlay muted poster="/themes/defaultNiimko/images/new/placeholder.jpg">
                <source src="/themes/defaultNiimko/images/new/slider.webm#t=0.1" type="video/webm"/>
            </SliderVideo>
            <Container>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column computer={8} tablet={12}>
                            <ContactsContainer>
                                <a href="tel:+78362422468">+7 8362 42-24-68</a>
                                <a href="tel:+78362383501">+7 8362 38-35-01</a>
                                <a href="mailto:nii.mko@yandex.ru">nii.mko@yandex.ru</a>
                                <Contacts currentAct={currentAct} color="#fff"/>
                            </ContactsContainer>
                            <TextDiv>
                                <SliderHeader>Оценка и мониторинг качества образования</SliderHeader>
                            </TextDiv>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column computer={12} tablet={16}>
                            <InvertedButton href={`//auth.${drupalHost}/signup`} basic secondary inverted $hideMobile={true}>
                                Зарегистрироваться
                            </InvertedButton>
                            <Helper onClick={handleClick}><i>Помощник в выборе сервиса</i></Helper>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </Container>
        </SliderContainer>
    )
}